<template>
	<div class="c-block-view-asset-header">
		<span>
			{{ title }}
		</span>
		<a v-if="asset.type !== 'youtube'" :class="[{ downloaded: downloaded === true }]" :href="downloadUrl(assetPath)" @click.prevent="onDownload(assetPath)">
			<span> Download </span>
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12.75 6C12.75 5.58579 12.4142 5.25 12 5.25C11.5858 5.25 11.25 5.58579 11.25 6V13.1893L8.53033 10.4697C8.23744 10.1768 7.76256 10.1768 7.46967 10.4697C7.17678 10.7626 7.17678 11.2374 7.46967 11.5303L11.4697 15.5303C11.7626 15.8232 12.2374 15.8232 12.5303 15.5303L16.5303 11.5303C16.8232 11.2374 16.8232 10.7626 16.5303 10.4697C16.2374 10.1768 15.7626 10.1768 15.4697 10.4697L12.75 13.1893V6ZM8 17.25C7.58579 17.25 7.25 17.5858 7.25 18C7.25 18.4142 7.58579 18.75 8 18.75H16C16.4142 18.75 16.75 18.4142 16.75 18C16.75 17.5858 16.4142 17.25 16 17.25H8Z"
					fill="currentColor"
				/>
			</svg>
		</a>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			downloaded: false,
		};
	},

	props: {
		title: {
			default: '',
		},
		asset: {
			default: '',
		},
	},

	computed: {
		assetPath: function () {
			if (!this.asset) {
				return;
			}

			return this.asset.assetPath;
		},
		baseUrl: function () {
			return this.$store.getters['config/baseUrl'];
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
	},

	methods: {
		downloadUrl: function (fileName) {
			let baseUrl = this.baseUrl;

			let str = `${baseUrl}/api/download/${fileName}`;
		},
		onDownload: function (fileName) {
			if (this.downloaded) {
				return;
			}

			let baseUrl = this.baseUrl;

			let str = `${baseUrl}/api/download/${fileName}`;

			this.downloadFile(str, fileName);
		},
		downloadFile: function (url, fileName) {
			if (!this.workspace.activated) {
				this.$store.dispatch('message/onPushEmailVerify');
				return;
			}
			this.$store.dispatch('message/onDownloadStarted');
			let assetUrl = this.assetUrl;
			var xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.responseType = 'blob';
			xhr.onload = function () {
				if (!this.response.size && this.response.size === 0) {
					window.open(`${assetUrl}/${fileName}`, '_blank').focus();
					return;
				}
				if (this.response.size < 60) {
					window.open(`${assetUrl}/${fileName}`, '_blank').focus();
				}
				var urlCreator = window.URL || window.webkitURL;
				var imageUrl = urlCreator.createObjectURL(this.response);
				var tag = document.createElement('a');
				tag.href = imageUrl;
				tag.target = '_blank';
				tag.download = fileName;
				document.body.appendChild(tag);
				tag.click();
				document.body.removeChild(tag);
			};
			xhr.onerror = (err) => {
				console.log(err);
				//this.$store.dispatch("message/onDownloadFailed");
				window.open(`${assetUrl},${fileName}`, '_blank').focus();
			};
			xhr.send();

			this.downloaded = true;
		},
	},
};
</script>

<style lang="scss">
.c-block-view-asset-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	min-height: 24px;
	margin: var(--margin-lg) 0;

	> span {
		font-weight: 450;
	}

	> a {
		display: flex;
		align-items: center;
		cursor: pointer;
		padding: var(--margin);
		padding-left: var(--margin-lg);
		background-color: var(--color-bg-1);
		border: var(--color-bg-4) solid 1px;
		border-radius: 99px;
		user-select: none;
		transition: all var(--transition-time-sm) ease-out;

		span {
			display: inline-block;
			margin-right: var(--margin);
			font-size: var(--font-size-sm);
			font-weight: 500;
		}

		svg {
			border-radius: 50%;
			box-shadow: 0 0 0 2px #fff;
		}

		&.downloaded {
			opacity: 0.5;
			color: #000;
		}

		&:hover,
		&:active {
			color: var(--color-secondary);
		}
	}
}
</style>
